var exports = {
  "c": "MessageDeleteTombstone.module__tombstoneAction___djNzcV",
};

module.exports = exports;
